import {
  withStateRefsValues,
  createComponentMapperModel,
  withCompInfo,
} from '@wix/editor-elements-integrations';
import type { VideoBoxDefinition } from '@wix/thunderbolt-components';
import type { VideoBoxProps } from '../VideoBox.types';
import * as TranslationKeys from './constants';
import { isExperimentOpen } from '@wix/editor-elements-common-utils';

export const props = withCompInfo<
  VideoBoxProps,
  VideoBoxDefinition,
  VideoBoxProps
>()(['translate', 'experiments'], ({ translate, experiments }, carmiData) => {
  const useWixMediaCanvas = isExperimentOpen(
    experiments,
    'specs.thunderbolt.useWixMediaCanvas',
  );
  const { fillLayers } = carmiData;
  return {
    ...carmiData,
    fillLayers: {
      ...fillLayers,
      useWixMediaCanvas,
    },
    translations: {
      ariaLabel:
        translate(
          TranslationKeys.ARIA_LABEL_NAMESPACE,
          TranslationKeys.VIDEOBOX_PLAY_ARIA_LABEL_KEY,
        ) || TranslationKeys.VIDEOBOX_PLAY_ARIA_LABEL_DEFAULT,
    },
  };
});

export const stateRefs = withStateRefsValues(['reducedMotion']);

export default createComponentMapperModel({ props, stateRefs });
